export const STATS_PREFIX = `packages.content_reporting`;

export enum ENTITY_TYPE {
    GIG = 'GIG',
    MESSAGE = 'MESSAGE',
    VIDEO_CALL = 'VIDEO_CALL',
    BRIEF = 'BRIEF',
    ATTACHMENT = 'ATTACHMENT',
    DEFAULT = 'DEFAULT',
}

export enum PARENT_ENTITY_TYPE {
    PORTFOLIO_PROJECT = 'PORTFOLIO_PROJECT',
    LIVE_PORTFOLIO_PROJECT = 'LIVE_PORTFOLIO_PROJECT',
    AI_CREATION_MODEL = 'AI_CREATION_MODEL',
}

export const STANDALONE_AUTO_COMPLETE_DELAY = 5000;
